import smBreadcrumb from '@/components/shared/sm-breadcrumb.vue'
import smTextField from '@/components/sm-components/sm-text-field.vue'
import smNumberField from '@/components/sm-components/sm-number-field.vue'
import smSelect from '@/components/sm-components/sm-select.vue'
import smCheckbox from '@/components/sm-components/sm-checkbox.vue'
import smDatePicker from '@/components/sm-components/sm-date-picker.vue'
import smTimerangePicker from '@/components/sm-components/sm-timerange-picker.vue'
import smMonthPicker from '@/components/sm-components/sm-month-picker.vue'
//import monthSmYearPicker from '@/components/sm-components/Monthsm-year-picker.vue';
import smYearPicker from '@/components/sm-components/sm-year-picker.vue'
import smDatetimePicker from '@/components/sm-components/sm-datetime-picker.vue'
import smTimePicker from '@/components/sm-components/sm-time-picker.vue'
import smTimemodePicker from '@/components/sm-components/sm-timemode-picker.vue'
import smEmployeePicker from '@/components/sm-components/sm-employee-picker.vue'
import smMultipleEmployeePicker from '@/components/sm-components/sm-multiple-employee-picker.vue'
import smUserPicker from '@/components/sm-components/sm-user-picker.vue'
import smOperatorPicker from '@/components/sm-components/sm-operator-picker.vue'
import smWorkflowPicker from '@/components/sm-components/sm-workflow-picker.vue'
import smDaterangePicker from '@/components/sm-components/sm-daterange-picker.vue'
import SmDaterangeMonthPicker from '@/components/sm-components/sm-daterange-month-picker.vue'
import smTextArea from '@/components/sm-components/sm-text-area.vue'
import smGrid from '@/components/sm-components/sm-grid.vue'
import smButton from '@/components/sm-components/sm-button.vue'
import smMonthNumberPicker from '@/components/sm-components/sm-month-number-picker.vue'

//import smMaintenance from '@/components/sm-components/sm-maintenance.vue';
import smUiCard from '@/components/shared/sm-ui-card.vue'
import smEmpty from '@/components/shared/sm-empty.vue'
// import smPrintPage from '@/components/utility/sm-print-page.vue';
import smEditor from '@/components/sm-components/TipTapEditor.vue'
//import smEditorTelegram from '@/components/sm-components/TipTapEditorTelegram.vue';
import smCropper from '@/components/sm-components/sm-cropper.vue'
import smFileUploader from '@/components/sm-components/sm-file-uploader.vue'
import smImportData from '@/components/sm-components/sm-import-data.vue'
import smPhotoPploader from '@/components/sm-components/sm-photo-uploader.vue'
import smLocationPicker from '@/components/sm-components/sm-location-picker.vue'
import smImage from '@/components/utility/sm-image.vue'
import smAutocomplete from '@/components/sm-components/sm-autocomplete.vue'
import smLottie from '@/components/sm-components/sm-lottie.vue'
import smFilePreview from '@/components/sm-components/sm-file-preview.vue'
import smRemarkDialog from '@/components/sm-remark-dialog.vue'
import smConfirmDialog from '@/components/sm-confirm-dialog.vue'
import smExportExcel from '@/components/sm-export-excel.vue'
//import easyDatatable from '@/components/sm-components/easydatatable.vue';
import smTabs from '@/components/sm-components/sm-tabs.vue'
import smDialolg from '@/components/sm-components/sm-dialog.vue'
import header from '@/components/reports/header.vue'
import WorkflowCondition from '@/components/WorkflowConditionBuilder.vue'
import SmStatusView from '@/components/sm-status-view.vue'
import SmCompanyPicker from '@/components/sm-components/sm-company-picker.vue'
import SmEmployeeTree from '@/components/sm-components/sm-employee-tree.vue'

const smPlugin = {
    install(Vue) {
        Vue.component('sm-breadcrumb', smBreadcrumb)
        Vue.component('sm-text-field', smTextField)
        Vue.component('sm-number-field', smNumberField)
        Vue.component('sm-select', smSelect)
        Vue.component('sm-checkbox', smCheckbox)
        Vue.component('sm-date-picker', smDatePicker)
        Vue.component('sm-timerange-picker', smTimerangePicker)
        Vue.component('sm-month-picker', smMonthPicker)
        //Vue.component('monthsm-year-picker', monthSmYearPicker);
        Vue.component('sm-year-picker', smYearPicker)
        Vue.component('sm-datetime-picker', smDatetimePicker)
        Vue.component('sm-time-picker', smTimePicker)
        Vue.component('sm-timemode-picker', smTimemodePicker)
        Vue.component('sm-employee-picker', smEmployeePicker)
        Vue.component('sm-user-picker', smUserPicker)
        Vue.component('sm-operator-picker', smOperatorPicker)
        Vue.component('sm-workflow-picker', smWorkflowPicker)
        //Vue.component('employee-profile-picker', employeeProfilePicker);
        Vue.component('sm-daterange-picker', smDaterangePicker)
        Vue.component('sm-daterange-month-picker', SmDaterangeMonthPicker)
        Vue.component('sm-text-area', smTextArea)
        Vue.component('sm-grid', smGrid)
        Vue.component('sm-button', smButton)
        ///Vue.component('sm-maintenance', smMaintenance);
        Vue.component('sm-ui-card', smUiCard)
        Vue.component('sm-empty', smEmpty)
        // Vue.component('printPage', smPrintPage);
        Vue.component('sm-editor', smEditor)
        //Vue.component('sm-editor-telegram', smEditorTelegram);
        Vue.component('sm-cropper', smCropper)
        Vue.component('sm-file-uploader', smFileUploader)
        Vue.component('sm-import-data', smImportData)
        Vue.component('sm-photo-uploader', smPhotoPploader)
        Vue.component('sm-location-picker', smLocationPicker)
        Vue.component('sm-image', smImage)
        Vue.component('sm-autocomplete', smAutocomplete)
        Vue.component('sm-lottie', smLottie)
        Vue.component('sm-remark-dialog', smRemarkDialog)
        Vue.component('sm-confirm-dialog', smConfirmDialog)
        Vue.component('sm-export-excel', smExportExcel)
        //Vue.component('easy-datatable', easyDatatable);
        Vue.component('sm-tabs', smTabs)
        Vue.component('sm-dialog', smDialolg)
        Vue.component('report-header', header)
        Vue.component('workflow-condition', WorkflowCondition)
        Vue.component('sm-status-view', SmStatusView)
        Vue.component('sm-company-picker', SmCompanyPicker)
        Vue.component('sm-employee-tree', SmEmployeeTree)
        Vue.component('sm-multiple-employee-picker', smMultipleEmployeePicker)
        Vue.component('sm-file-preview', smFilePreview)
        Vue.component('sm-month-number-picker', smMonthNumberPicker)
    },
}

export default smPlugin
